import { useCallback } from 'react';

export const useScroll = (option: {
  scrollKey?: string;
  smooth?: boolean;
}) => useCallback((scrollCode: string) => {
  const scrollKey = option.scrollKey || 'id';
  const targetElem = scrollKey === 'id'
    ? document.getElementById(scrollCode)
    : document.querySelector(`[data-${scrollKey}="${scrollCode}"]`);
  if (targetElem) {
    const targetDOMRect = targetElem.getBoundingClientRect();
    const targetTop = targetDOMRect.top + window.scrollY - 36;
    window.scrollTo({
      top: targetTop,
      behavior: 'smooth',
    });
  }
}, [option.scrollKey, option.smooth]);
